import React, { useEffect, useMemo } from 'react';
import { Alert, Box, Flex, Spinner } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

import { usePreIpoEntity } from '../hooks/usePreIpoEntity';
import StockSecFilings from './stock/StockSecFilings';
import { StockReviewModeProvider } from './stock/StockReviewModeContext';

function PreIpoSecFilings() {
  const { cik } = useParams();
  const apiBaseUrl = useMemo(
    () => (process.env.REACT_APP_API_URL || '').replace(/\/+$/, ''),
    [],
  );
  const { entity, error, status } = usePreIpoEntity(cik, apiBaseUrl);

  useEffect(() => {
    if (!entity?.company_name) return undefined;
    const previousTitle = document.title;
    document.title = `${entity.company_name} Pre-IPO SEC Filings | DCF Teacher`;
    return () => {
      document.title = previousTitle;
    };
  }, [entity]);

  if (status === 'loading') {
    return (
      <Flex minH="240px" align="center" justify="center">
        <Spinner size="lg" />
      </Flex>
    );
  }

  if (status === 'error' || !entity) {
    return (
      <Box p={{ base: 4, md: 6 }}>
        <Alert.Root status="error">
          <Alert.Indicator />
          <Alert.Content>{error || 'This SEC entity could not be found.'}</Alert.Content>
        </Alert.Root>
      </Box>
    );
  }

  return (
    <StockReviewModeProvider ticker={`CIK-${entity.cik}`}>
      <StockSecFilings preIpoEntity={entity} />
    </StockReviewModeProvider>
  );
}

export default PreIpoSecFilings;
